import React, {useEffect, useRef, useState} from "react";
import Badge from '@material-ui/core/Badge';
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {Transition} from "react-transition-group";
import { useHistory } from "react-router-dom";

import useMediaQuery from "@material-ui/core/useMediaQuery";
import {getNextAvailableTime} from "../HTTPS/apisInterface";
const useStyles = makeStyles((theme) => ({
	root: {
		borderRadius:0,
		display: 'flex',
		'& > *': {
			margin: theme.spacing(1),
			maxWidth:'230px',
		},
	},
	hide:{
		display:'none'
	},
	small: {
		width: theme.spacing(3),
		height: theme.spacing(3),
	},
	large: {
		objectFit:'cover',
		width: theme.spacing(17),
		height: theme.spacing(17),
	},
}));
const duration = 320;

const defaultStyle = {
	transition: `opacity ${duration}ms ease-in-out`,
	opacity: 0,
}

const transitionStyles = {
	entering: { opacity: 1 },
	entered:  { opacity: 1 },
	exiting:  { opacity: 0 },
	exited:  { opacity: 0 },
};
export default function (props) {
	const classes = useStyles();
	const directPortalLocationPermalinks = [
		'jaguar-land-rover-metropool-zuid',
		'bmw-mini-jorssen-zuid',
	];
	const directPortalLocationNames = [
		'Carrosserie Zuid - Alle Merken',
		'Carrosserie Zuid - Alle merken',
		'Carrosserie Noord - Alle Merken',
		'Carrosserie Noord - Alle merken',
		'BMW - MINI Jorssen Zuid',
		'Jaguar - Land Rover Metropool Zuid',
	];
	const locationDisplayName = props?.location?.displayName || props?.location?.name;
	const shouldRedirectToPortal = (
		directPortalLocationPermalinks.includes(props?.location?.permalink) ||
		directPortalLocationNames.includes(props?.location?.name) ||
		directPortalLocationNames.includes(locationDisplayName)
	);
	const locationNameLower = (props?.location?.name || '').toLowerCase();
	const displayNameLower = (locationDisplayName || '').toLowerCase();
	const isNoordLocation = locationNameLower.includes('noord') || displayNameLower.includes('noord');
	const portalUrl = isNoordLocation
		? 'https://selfserviceportal.planmanager.be/metropool'
		: 'https://selfserviceportal.planmanager.be/jorssen2000';
	const locationAddress =
		props?.location?.address ||
		props?.location?.location?.address ||
		[props?.location?.street, props?.location?.houseNumber, props?.location?.postalCode, props?.location?.city]
			.filter(Boolean)
			.join(' ');

	const locationSubtitle = props?.location?.name === 'BMW - MINI Jorssen Zuid'
		? (locationAddress || props?.location?.title || 'Antwerpsesteenweg 126, 2630 Aartselaar')
		: props?.location?.title;
	const StyledBadge = withStyles((theme) => ({
		badge: {
			backgroundColor: props.location.period == null || props.location.period.length === 0 ? '#b80c0c' :'#44b700',
			color: props.location.period == null || props.location.period.length === 0 ? '#b80c0c' :'#44b700',
			boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
			'&::after': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				borderRadius: '50%',
				animation: `$ripple 1.2s ${props.location.period === null || props.location.period.length === 0	  ? 'once' : 'infinite'} ease-in-out`,
				border: '1px solid currentColor',
				content: '""',
			},
		},
		'@keyframes ripple': {
			'0%': {
				transform: 'scale(.8)',
				opacity: 1,
			},
			'100%': {
				transform: 'scale(2.4)',
				opacity: 0,
			},
		},
	}))(Badge);
	const [time,setTime] = useState([]);
	const [isLoaded,setIsLoaded] = useState(false);
	const [employeeImage,setEmployeeImage] = useState('');
	const [inProp, setInProp] = useState(false);
	const history = useHistory();
	const isMobile = useMediaQuery('(max-width:520px)');
	const getEmployeeTime = ()=>{
		if(props.location && props.location.period){
			setTime(props.location.period);
		}
	}
	const employeeInfoRef = useRef(null);


	useEffect(()=>{
		setIsLoaded(false);
		getEmployeeTime();
		const img = new Image();
		const fallbackImage = '/assets/img/manplaceholder.png';
		img.src = props?.location?.image ? props?.location?.image : fallbackImage; // by setting an src, you trigger browser download
		img.onload = () => {
			// when it finishes loading, update the component state
			setIsLoaded(true);
			setEmployeeImage(img.src);
			setTimeout(()=>{
				setInProp(!inProp)
			},0)
		}
		img.onerror = () => {
			// Ensure the card still renders when backend image URLs are broken.
			setIsLoaded(true);
			setEmployeeImage(fallbackImage);
			setTimeout(()=>{
				setInProp(!inProp)
			},0)
		}
	},[props.location])
	return(
		 <div >
			 {isLoaded ? <React.Fragment>
				 <Transition  in={inProp} timeout={duration}>
					 {state=>(
							<div style={{
								...defaultStyle,
								...transitionStyles[state]
							}}>
								<Card   style={{background:`linear-gradient(180deg, #5CAF95 50%,white 50%)`}} className={`${classes.root } employeeContainer`}>
									<CardActionArea onClick={(e)=>{
										if (shouldRedirectToPortal) {
											window.open(portalUrl, '_blank', 'noopener,noreferrer');
											return;
										}
										employeeInfoRef.current.classList.contains("hide") ? employeeInfoRef.current.classList.remove("hide") : employeeInfoRef.current.classList.add("hide");
									}}>
										<div className={"imageContainer"}>
											<CardMedia
												 component="img"
												 alt={locationDisplayName}
												 height="150px"
												 id={`${locationDisplayName.split(" ").join('')}`}
												 style={{objectFit:"cover",width:'150px',borderRadius:'50%',fontFamily:'obvia,sans-serif'}}
												 image={employeeImage}
												 title={locationDisplayName}
											/>
										</div>
										<StyledBadge
											 overlap="circle"
											 anchorOrigin={{
												 vertical: 'bottom',
												 horizontal: 'right',
											 }}
											 style={{position:'absolute',right:'27%',bottom:'50%'}}
											 variant="dot"
										/>

										<CardContent style={{textAlign:'center'}}>
											<Typography style={{fontFamily:'obvia,sans-serif',color:'black !important'}} gutterBottom variant="h5" component="h2">
												{locationDisplayName}
											</Typography>
											<Typography style={{fontFamily:'obvia,sans-serif',color:'black'}} variant="body2" component="p">
												{locationSubtitle}
											</Typography>
										</CardContent>
									</CardActionArea>

								</Card>
								<Card ref={employeeInfoRef}   style={{flexDirection:'column',backgroundColor:'#FAFAFA',overflowX:'hidden',overflowY:'scroll',maxHeight:'450px',alignItems:props.location.isAvailable ? '':'center'}}  className={classes.root}>

									{ shouldRedirectToPortal ? (
										<div style={{marginLeft:"auto",marginRight:'auto',textAlign:'center'}}>
											<Button
												onClick={() => {
													window.open(portalUrl, '_blank', 'noopener,noreferrer');
												}}
												style={{margin:'11px',width:'fit-content',alignSelf:'center',backgroundColor:'#2A2C35',color:'white'}}
												color={"primary"}
												variant="contained"
											>
												Ga naar selfservice portal
											</Button>
										</div>
									) : props.location.isAvailable ? time && time.length > 0 ? time.map(item=>{
										return <div  key={props.location.name + Math.random()} style={{marginLeft:"auto",marginRight:'auto',}} className={'time'}>
											<span style={{marginLeft:'20px',marginRight:'20px'}}>{item.timeSlot}</span>
											<Button disabled={!item.available}  onClick={(e)=>{
												props.reactGA.event({
													category: "Booking Calendar",
													action: "Select Timeslot",
													label:item.timeSlot
												})
												history.push(`${history.location.pathname.split('/')[1]}/${props.location.permalink}/booking${history.location.search}`,{employee:props.location,currentLocation:props.location,currentDate:props.date,timeSlot:item.timeSlot})
												}} value={props.location.name}
															style={{margin:isMobile ? 'unset':'11px',width:'fit-content',alignSelf:'center',backgroundColor:`${item.available  ? '#2A2C35':''}`,color:`${item.available ? 'white':''}`}} color={"primary"} variant="contained">{item.available ? 'Boek' :'Bezet'}</Button></div>
									}):<div style={{textAlign:'center'}}>Geen Afspraak</div> :<div>
										<p>Niet Beschikbaar Vandaag</p>
										<Button onClick={async ()=>{
											let selectedDate  = props.date.toLocaleDateString("en-EG").split("/").reverse();
     										let month = selectedDate[2];
											selectedDate[2] = selectedDate[1];
											selectedDate[1] = month;
											selectedDate = selectedDate.join('-');
											const employeeEmail = props.location.email;
											props.loading(true);
											props.setProgress(false);
											props.setLoadingText("We zoeken naar de eerstvolgende beschikbaarheid voor deze verkoper ..." );
											const response = await	getNextAvailableTime(employeeEmail,selectedDate);
											props.changeDate(new Date(response));

										}
										} style={{backgroundColor:"#9fb4b8",width:'187px',color:'white'}}>Ga naar het volgende beschikbare tijdslot</Button>
									</div>}

								</Card>
							</div>
					 )}
				 </Transition>
				 </React.Fragment> :''}
		 </div>

	)
}
